export default __webpack_public_path__ + "static/media/case_top_bg.5cbd0577.png";